import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import './fonts/AvenirLTStd-Black.otf';
import './fonts/AvenirLTStd-Book.otf';
import './fonts/PlayfairDisplay-Regular.ttf';

ReactDOM.render(<App />, document.getElementById('root'));
